// store/thunks/auth/verifyRecoveryOtpThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { RecoveryVerificationDTO } from '@/types/dtos.types';
import { sendRecoveryTwoFactorThunk } from '@/store/thunks/auth/sendRecoveryTwoFactorThunk';

export const verifyRecoveryOtpThunk = createAdminAsyncThunk<
  RecoveryVerificationDTO,
  { emailAddress: string; code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryOtpThunk',
  async({ emailAddress, code }, {dispatch, extra: { authService }, rejectWithValue }) => {
    try {
      const result = await authService.verifyRecoveryOtp({ emailAddress, code });

      const recoveryToken = String(result.recoveryToken);

      await dispatch(sendRecoveryTwoFactorThunk({ recoveryToken })).unwrap();
      return result;
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send reset password email';
      return rejectWithValue({ message });
    }
  }
);
